<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_chap"><a href="#/chap1"><span class="som_chap_n">1</span>Sensing God in Wine</a></div>
<div class="SOM_chap"><a href="#/chap2"><span class="som_chap_n">2</span> A Joyful Journey to a Spiritual Gift</a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="som_chap_n">3</span> We Are Thirsty</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="som_chap_n">4</span> Wine Is God’s Way of Kissing Humanity</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="som_chap_n">5</span> Coming Home</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="som_chap_n">6</span> Making Peace with Wine and Food</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="som_chap_n">7</span> To Drink Is to Pray</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="som_chap_n">8</span> Learning About Joy from the Wine Press</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="som_chap_n">9</span> Convivial Celebrations</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="som_chap_n">10</span> Wine, Sex, and God</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><span class="som_chap_n">11</span> Wine, Health, and Healing</span></div>
<div class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><span class="som_chap_n">12</span> From Intimidation to Appreciation</span></div>
<div class="SOM_chap"><span href="#/chap13" title="Link target outside of Sample"><span class="som_chap_n">13</span> Awakening the Muse</span></div>
<div class="SOM_chap"><span href="#/chap14" title="Link target outside of Sample"><span class="som_chap_n">14</span> Musings on Community from a Wine Pilgrim</span></div>
<div class="SOM_appen"><span href="#/appen2" title="Link target outside of Sample">Benediction: Wine as a Blessing</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Gratitude</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Digestif: How to Savor Wine Soulfully</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Discussion Guide and Wine Tasting Tips</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Praise for <i>The Soul of Wine</i></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?c872e112